import * as React from "react";

import { useSelector } from "react-redux";
import { Profile } from "../../components/CoreUsers/Profile";
import { State } from "../../interfaces/state";

export const CoreUserShowScene: React.FC = (): JSX.Element => {
  const currentUser = useSelector((state: State) => state.currentUser);
  return (
    <div>
      <Profile currentUser={currentUser} stateProp="currentUser" />
    </div>
  );
};
